import { render, staticRenderFns } from "./GetFeedback.vue?vue&type=template&id=7ddac786&scoped=true&"
import script from "./GetFeedback.vue?vue&type=script&lang=js&"
export * from "./GetFeedback.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7ddac786",
  null
  
)

export default component.exports